import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { cloudSaveNames } from "./emulator/cloudSaves";
import { accountAtLoad, settleProfile, tokenAtLoad } from "./emulator/profiles";
import { settlePreferences } from "@common/preferences";
import { recordVisit } from "@common/visit";
import { startTheme } from "@common/themePreference";
import "./index.css";

const container = document.getElementById("root")!;
recordVisit();
// index.html already set the theme; this follows the OS for "system" and
// takes the account's choice once settlePreferences brings it.
startTheme();

// Before anything reads the browser's saves and settings, make them the
// signed-in account's.
settleProfile(
  accountAtLoad(),
  () => {
    container.textContent = "Switching to this account's saves…";
  },
  {
    cloudNames: async () => {
      const token = tokenAtLoad();
      return token ? cloudSaveNames(token) : null;
    },
  },
)
  .then(() => settlePreferences())
  .then(() =>
    ReactDOM.createRoot(container).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    ),
  );
